module.exports = __webpack_public_path__ + "img/MES10Indice5.70ac22c3.png";